module.exports = "https://static.wmbcdn.com/uniweb/images/60a7d58e34ffbde7262133d9ec3a322f.svg";